<app-colored-background [backgroundColor]="'#03A97F'">
  <app-header
    [title]="locale.currentTranslation.personalInformationHeader"
    [useWhiteFontColor]="true"
    [showProgressIndicator]="false"
    [showClose]="false"
    data-testid="personal-information-finished-header"
  ></app-header>
  <div data-testid="personal-information-finished-container">
    <div class="base-content-container" data-testid="personal-information-finished-content">
      <div class="headline1" style="color: #FFFFFF" data-testid="personal-information-finished-headline">
        {{ locale.currentTranslation.finishPersonalInformationHeadline }}
      </div>
      <div class="text-body1" style="color: #FFFFFF" data-testid="personal-information-finished-body-text">
        {{ locale.currentTranslation.finishPersonalInformationText }}
      </div>
    </div>
    <app-finish-box data-testid="personal-information-finished-finish-box"></app-finish-box>
    <div class="main-button-spacing" data-testid="personal-information-finished-button-spacing">
      <button class="main-button" routerLink="/data-correctness-confirmation" data-testid="btn-next">{{ locale.currentTranslation.next }}</button>
    </div>
  </div>

  <app-footer data-testid="personal-information-finished-footer"></app-footer>
</app-colored-background>
